import React from "react";
import { Link } from "react-router-dom";
import { PageHero } from "../components/pageHero";
import { Cta } from "../components/cta";

const Granite = ({ data }) => {
  const page = data.GranitePage;
  const contact = data.Contact;

  const contactValue = (type) => {
    switch (type) {
      case "whatsapp":
        return {
          text: contact.whatsapp,
          href: `https://wa.me/${(contact.whatsapp || "").replace(/[^0-9]/g, "")}`,
          external: true,
        };
      case "phone":
        return { text: contact.phone, href: `tel:${(contact.phone || "").replace(/\s/g, "")}` };
      case "email":
        return { text: contact.email, href: `mailto:${contact.email}` };
      default:
        return { text: contact.address };
    }
  };

  return (
    <>
      <PageHero
        title={page.heroTitle}
        subtitle={page.heroSubtitle}
        image="img/hero-granite.jpg"
      />

      <div className="page-section product-intro">
        <div className="container">
          <div className="col-md-10 col-md-offset-1 text-center">
            <p className="lead">{page.intro}</p>
            <ul className="product-nav">
              <li><a href="#wholesale">Wholesale</a></li>
              <li><a href="#varieties">Varieties</a></li>
              <li><a href="#formats">Formats &amp; Finishes</a></li>
              <li><a href="#granite-contact">Contact</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div id="wholesale" className="page-section alt wholesale-section">
        <div className="container">
          <div className="row vcenter">
            <div className="col-md-6">
              <span className="eyebrow dark">{page.wholesale.eyebrow}</span>
              <h2>{page.wholesale.title}</h2>
              {page.wholesale.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              <ul className="check-list">
                {page.wholesale.bullets.map((b, i) => (
                  <li key={i}>{b}</li>
                ))}
              </ul>
            </div>
            <div className="col-md-6 product-media">
              <img
                src={page.wholesale.image}
                className="img-responsive framed"
                alt="Granite slabs in the International Rocks yard"
              />
            </div>
          </div>
        </div>
      </div>

      <div id="stats">
        <div className="container">
          <div className="row">
            {page.stats.map((s, i) => (
              <div key={i} className="col-xs-6 col-md-3 stat-item">
                <span className="stat-value">{s.value}</span>
                <span className="stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div id="varieties" className="page-section granite-varieties">
        <div className="container">
          <div className="col-md-10 col-md-offset-1 section-title text-center">
            <h2>{page.varietiesTitle}</h2>
            <p>{page.varietiesIntro}</p>
          </div>
          <div className="card-grid material-grid">
            {page.varieties.map((v) => (
              <div key={v.id} id={v.id} className="material-card granite-card">
                <div className="material-img">
                  <img src={v.image} alt={`${v.name} granite`} className="img-responsive" />
                </div>
                <div className="material-body">
                  <h3>{v.name}</h3>
                  <span className="granite-origin">
                    <i className="fa fa-map-marker"></i> {v.origin}
                  </span>
                  <span className="material-meta">{v.meta}</span>
                  <p>{v.text}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center section-footer">
            <Link to="/contact" className="btn btn-custom">
              Request Samples
            </Link>
          </div>
        </div>
      </div>

      <div id="formats" className="page-section alt">
        <div className="container">
          <div className="col-md-10 col-md-offset-1 section-title text-center">
            <h2>{page.formats.title}</h2>
            <p>{page.formats.intro}</p>
          </div>
          <div className="card-grid cols-4 format-grid">
            {page.formats.groups.map((g, i) => (
              <div key={i} className="format-card">
                <i className={g.icon}></i>
                <h3>{g.title}</h3>
                <ul>
                  {g.items.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div id="granite-contact" className="page-section granite-contact">
        <div className="container">
          <div className="row vcenter">
            <div className="col-md-5">
              <span className="eyebrow dark">{page.contact.eyebrow}</span>
              <h2>{page.contact.title}</h2>
              <p>{page.contact.text}</p>
              <p className="granite-contact-note">{page.contact.note}</p>
              <Link to="/contact" className="btn btn-custom">
                Send an Enquiry
              </Link>
            </div>
            <div className="col-md-6 col-md-offset-1">
              <div className="granite-contact-card">
                {page.contact.items.map((item, i) => {
                  const value = contactValue(item.type);
                  return (
                    <div key={i} className="granite-contact-row">
                      <i className={item.icon}></i>
                      <div>
                        <span className="granite-contact-label">{item.label}</span>
                        {value.href ? (
                          <a
                            href={value.href}
                            {...(value.external
                              ? { target: "_blank", rel: "noreferrer" }
                              : {})}
                          >
                            {value.text}
                          </a>
                        ) : (
                          <span className="granite-contact-value">{value.text}</span>
                        )}
                      </div>
                    </div>
                  );
                })}
                <div className="granite-contact-row">
                  <i className="fa fa-clock-o"></i>
                  <div>
                    <span className="granite-contact-label">Office hours</span>
                    <span className="granite-contact-value">{contact.hours}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p className="image-credits">{page.credits}</p>
        </div>
      </div>

      <Cta
        title="Need a granite price by the container?"
        text="Tell us the variety, finish, thickness, square metres and destination — we answer with samples, a written offer and a loading date."
        buttonLabel="Request a Quote"
      />
    </>
  );
};

export default Granite;
